module.exports = "<ng-container *ngIf=\"urlToLoad\">\n    <iframe [src]=\"urlToLoad | safe: 'resourceUrl'\" class=\"iframe-full-screen\" frameborder=\"0\" scrolling=\"no\"></iframe>\n    <div class=\"iframe-backdrop\"></div>\n</ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/iframe/iframe.component.html
// module id = ./web/modern/components/common/iframe/iframe.component.html
// module chunks = 0